// extracted by mini-css-extract-plugin
module.exports = {"notifications":"styles_notifications__WwJRq","notification":"styles_notification__8dVCU","info-icon":"styles_info-icon__Vr64m","close-button":"styles_close-button__aCFFN"};